import styled from 'styled-components';

export const InnerWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.neutral.neutral98};
    border-radius: 25px;
    margin-top: 20px;
    padding: 28px;
    height: fit-content;
`;
